import * as z from 'zod';

export const CreateTicketValidation = z.object({
  subject: z
    .string()
    .optional()
    .refine(
      (val) => !val || val.trim() === '' || val.trim().length <= 40,
      'عنوان تیکت حداکثر باید 40 کاراکتر باشد'
    ),
  description: z
    .string()
    .min(2, 'متن پیام باید حداقل 2 کاراکتر باشد')
    .max(3000, 'متن پیام نباید بیشتر از 3000 کاراکتر باشد'),
});

export const FeedbackValidation = z.object({
  rank: z.number().min(1, 'لطفاً امتیاز خود را انتخاب کنید').max(5),
  description: z.string().max(3000, 'توضیحات نباید بیش از ۳۰۰۰ کاراکتر باشد').optional(),
});
